import React, { useState, useRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { Slider } from "primereact/slider";
import ImageUploadForm from "./ImageUploadForm";
import HtmlContentForm from "./HtmlContentForm";
import { getContentTypeIdFromType, CONTENT_IMAGE_HTML } from "../Utils";
import { SecondaryButton } from "../../../../components/Buttons";

const generateState = (model) => {
  let size = 50;
  let data = [];
  let isImageLeft = true;
  try {
    data = JSON.parse((model || {}).body || "[]");
  } catch(err) {
    console.error("Error:", model, err);
  }
  if (data.length === 2) {
    const width = parseInt(((data[0].style || {}).width || "50%").replace("%", ""));
    // console.log("<< Data", data, width);
    if (!isNaN(width)) {
      size = width;
    }
    // console.log("HtmlImageContentForm - Image Data:", data[0]);
    if (data[0].isLeft !== undefined && !data[0].isLeft) {
      isImageLeft = false;
      size = 100 - size;
    }
  }
  return { size, isImageLeft, data };
};

const HtmlImageContentForm = React.forwardRef(({ className, pageId, model }, ref) => {
  const initial = generateState(model);
  const [size, setSize] = useState(initial.size);
  const [isImageLeft, setIsImageLeft] = useState(initial.isImageLeft);
  const [data, setData] = useState(initial.data);

  const imageFormRef = useRef(null);
  const htmlFormRef = useRef(null);

  const getData = (noValidate, pIsImageLeft) => {
    const imageData = imageFormRef.current.getModel(noValidate);
    const htmlData = htmlFormRef.current.getModel(noValidate);
    if (!imageData || !htmlData) {
      return null;
    }
    // console.log("<< HtmlImageContentForm.getData() size", size);
    const resolvedIsImageLeft = (pIsImageLeft !== undefined) ? pIsImageLeft : isImageLeft;
    if (imageData) {
      imageData.style = { width: `${resolvedIsImageLeft ? size : 100 - size}%` };
    }
    if (htmlData) {
      htmlData.style = { width: `${resolvedIsImageLeft ? 100 - size : size}%` };
    }
    return [ imageData, htmlData ];
  };

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      const body = getData(noValidate, isImageLeft);
      if (!body) {
        return null;
      }
      const { id } = model;
      body[0].isLeft = isImageLeft;
      return {
        id,
        content_type_id: getContentTypeIdFromType(CONTENT_IMAGE_HTML),
        body: JSON.stringify(body)
      };
    }
  }), [isImageLeft, size, model]);

  const switchPositions = () => {
    const newIsImageLeft = !isImageLeft;
    const newData = getData(true, newIsImageLeft);
    setIsImageLeft(newIsImageLeft);
    setData(newData);
  };

  const imageMarkup = (
    <ImageUploadForm
      ref={imageFormRef}
      model={data[0]}
      expand
    />
  );
  const suffix = `${Math.random()}`.split(".").join("-");
  const panelId=`${pageId}-HI${suffix}`;
  const htmlMarkup = (
    <div id={panelId}>
      <HtmlContentForm
        ref={htmlFormRef}
        model={data[1]}
        pageId={panelId}
      />
    </div>
  );
  console.log("HtmlImageContentForm.render()", { size, isImageLeft, data });
  return (
    <div className={`html-image-content-form ${className} pad`}>
      <div className="pad-tb clearfix">
        <SecondaryButton
          size="small"
          onClick={switchPositions}
        >
          {`Bild nach ${isImageLeft ? "rechts" : "links"}`}
        </SecondaryButton>
      </div>
      <div className="pad-top pad-big-btm clearfix" style={{zIndex: 2}}>
        <Slider
          value={size}
          onChange={(e) => setSize(e.value)}
        />
      </div>
      <div className="w3-cell-row">
        <div className="w3-cell w3-cell-top pad-sm-rht" style={{ width: `${size}%`}}>
          {isImageLeft ? imageMarkup : htmlMarkup}
        </div>
        <div className="w3-cell w3-cell-top pad-sm-lft" style={{ width: `${100 - size}%`}}>
          <div className="display-block">{isImageLeft ? htmlMarkup : imageMarkup}</div>
        </div>
      </div>
    </div>
  );
});

HtmlImageContentForm.displayName = "HtmlImageContentForm";

HtmlImageContentForm.propTypes = {
  pageId: PropTypes.string,
  className: PropTypes.string,
  model: PropTypes.object,
};

HtmlImageContentForm.defaultProps = {
  className: "",
  model: { body: "" },
};

export default HtmlImageContentForm;
